import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import "./login.css";
import Footer from "../footer/footer.js";
import { Link, useNavigate } from "react-router-dom";
import Header from "../header/header.js";
import { useLoginHook } from "./useLoginHook.js";

const Login = () => {
  const {
    showPassword,
    checkBox,
    saveUsername,
    validationSchema,
    togglePasswordVisibility,
    handleRememberMe,
    rememberMeCheck,
    handleSubmit,
  } = useLoginHook();

  return (
    <>
      <Header />
      <div className="main-container">
        <div className="container-adjust h-100">
          <div className="row h-100">
            {/* Left Section */}
            <div className="col-md-6 d-flex flex-column align-items-center justify-content-center text-white">
              <div className="left-font">
                <h1>Admin Login</h1>
                <ul>
                  <li>World First Welfare 2x2 via technology</li>
                  <li>Benefit for everyone around the globe</li>
                  <li>Help each other in good deeds</li>
                  <li>We hope for a long and successful journey with you</li>
                  <li>Established in 2020</li>
                </ul>
              </div>
            </div>
            <div className="vertical-line col-md-1"></div>
            {/* Right Section */}
            <div className="col-md-5 d-flex align-items-center justify-content-center bg-white">
              <div className="w-75">
                <h2 className="text-center">Welcome</h2>
                <p className="text-center text-muted">
                  Please login to Admin Dashboard.
                </p>
                <Formik
                  initialValues={{
                    email: saveUsername ? saveUsername : "",
                    password: "",
                    remember_me: false,
                  }}
                  validationSchema={validationSchema}
                  onSubmit={(values, { setSubmitting }) => {
                    handleSubmit(values, { setSubmitting });
                    rememberMeCheck(values);
                  }}
                >
                  {({ isSubmitting, errors, touched }) => (
                    <Form>
                      <div className="mb-3">
                        <Field
                          type="email"
                          name="email"
                          className={`form-control ${
                            errors.email && touched.email ? "field-error" : ""
                          }`}
                          placeholder="Email"
                        />
                        <ErrorMessage
                          name="email"
                          component="div"
                          className="text-danger small"
                        />
                      </div>

                      <div className="mb-3 position-relative">
                        <Field
                          type={showPassword ? "text" : "password"}
                          name="password"
                          className={`form-control ${
                            errors.password && touched.password
                              ? "field-error"
                              : ""
                          }`}
                          placeholder="Password"
                        />
                        <button
                          type="button"
                          onClick={togglePasswordVisibility}
                          className="btn-eye"
                        >
                          <i
                            className={`fa ${
                              showPassword ? "fa-eye-slash" : "fa-eye"
                            }`}
                          ></i>
                        </button>
                        <ErrorMessage
                          name="password"
                          component="div"
                          className="text-danger small"
                        />
                        <input
                          type="checkbox"
                          name="remeber_me"
                          className="form-check-input remember-me float-end  mt-2 ms-1"
                          onClick={handleRememberMe}
                        />
                        <label className="float-end mt-1">Remember Me</label>
                      </div>

                      <button
                        type="submit"
                        className="btn btn-green w-100 mb-3 text-white"
                      >
                        {isSubmitting ? (
                          <i className="fas fa-spinner fa-spin"></i>
                        ) : (
                          "Login"
                        )}
                      </button>
                    </Form>
                  )}
                </Formik>
                <div className="text-center">
                  Don't have an account?{" "}
                  <Link to="/join-us" className="text-muted">
                    Join Us
                  </Link>
                </div>
                <div className="text-center">
                  <Link to="/forget-password" className="text-muted">
                    Forgotten Your Password?
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Login;
